import './reviews.css';
import { useEffect, useState } from 'react';
import perImage from '../../../assets/icons/trvto_tourGuideSelected.png';
import ReviewStars from '../../reviewStars/ReviewStars';
import { getReviewsData } from '../../../api/infoAPI';
// import { getReviewDate } from "../../../utils/date";

export default function Reviews({ data, type }) {
    const [reviews, setReviews] = useState([]);
    useEffect(() => {
        if (!data?._id) return;
        const getReviews = async () => {
            try {
                const res = await getReviewsData(type || 'trip', data._id, 0, 20);
                setReviews(Array.isArray(res?.data) ? res.data : []);
            } catch (error) {
                setReviews([]);
            }
        };
        getReviews();
    }, [data?._id, type]);

    return (
        <div>
            {reviews?.map((review, reviewIndex) => {
                return (
                    <div key={reviewIndex} className='reviewDiv'>
                        <div className='reviewImgText'>
                            <img src={perImage} alt={review?.userName + 'image'} className='reviewImg' />
                            <div className='reviewStarsName'>
                                <span className='reviewUserName'>{review?.userName}</span>
                                <div className='reviewNameTime'>
                                    <ReviewStars rating={review?.rating} />
                                    <span className='reviewDate'>{review?.packId?.title}</span>
                                    {/* <span className="reviewDate">{getReviewDate(review.createdAt)}</span> */}
                                </div>
                                <span className='reviewComment'>{review?.comment}</span>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
